<template>
  <div class="">
    <div class="guahaopage1">
      <div class="x-wrap m-main">
        <!-- <div class="title1">预约挂号</div>
        <div class="pubctabs1 clear">
          <a href="/web_appointment.html">网站预约</a>
          <a href="/guahao.html">APP 预约</a>
          <a href="/weixinyuyue.html">微信预约</a>
          <a href="/dianhuayuyue.html">电话预约</a>
          <a href="/yitijiyuyue.html" class="now">一体机预约</a>
        </div> -->
      </div>
      <div class="guahao5page1">
        <div class="x-wrap m-main clear">
          <div class="leftbox mCustomScrollbar _mCS_1">
            <div
              id="mCSB_1"
              class="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
              style="max-height: none;"
              tabindex="0"
            >
              <div
                id="mCSB_1_container"
                class="mCSB_container"
                style="position:relative; top:0; left:0;"
                dir="ltr"
              >
                <div class="list">
                  <div class="a1 item now">
                    <div class="li">
                      <br />
                      <a>一体机预约</a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="mCSB_1_scrollbar_vertical"
                class="mCSB_scrollTools mCSB_1_scrollbar mCS-light mCSB_scrollTools_vertical"
                style="display: none;"
              >
                <div class="mCSB_draggerContainer">
                  <div
                    id="mCSB_1_dragger_vertical"
                    class="mCSB_dragger"
                    style="position: absolute; min-height: 30px; display: block; height: 367px; max-height: 380px; top: 0px;"
                  >
                    <div
                      class="mCSB_dragger_bar"
                      style="line-height: 30px;"
                    ></div>
                  </div>
                  <div class="mCSB_draggerRail"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="rightbox">
            <div v-if="radioValue == 1" class="inner">
              <div class="box2">
                <div class="tit2">
                  <span class="s1">一体机预约</span>
                </div>
               <div class="content">
                  <p class="MsoNormal" style="text-indent:21.0000pt;vertical-align:middle;">
                    <span style="text-indent:21pt;font-size:16px;font-family:Arial;line-height:2;color:#000000;">一、自助挂号：</span> 
                  </p>
                  <p class="MsoNormal" style="text-indent:21.0000pt;vertical-align:middle;">
                    <span style="text-indent:21pt;font-size:16px;font-family:Arial;line-height:2;color:#000000;">持就诊卡患者（医保卡、身份证）在医院自助服务终端上进行挂号业务。</span> 
                  </p>
                  <p class="MsoNormal">
                    <span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">自助挂号流程如下：在屏幕上选挂号</span><span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">/取号 → 依提示插入就诊卡（医保卡、身份证） → 选当日挂号业务 → 选门诊科室 → 选医生 → &nbsp;确认挂号并支付挂号费→ 打印业务凭证。</span> 
                  </p>
                  <p class="MsoNormal">
                    <br>
                  </p>
                  <p class="MsoNormal" style="text-indent:21.0000pt;vertical-align:middle;">
                    <span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">二、预约挂号</span> 
                  </p>
                  <p class="MsoNormal" style="text-indent:21.0000pt;vertical-align:middle;">
                    <span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">持就诊卡患者（医保卡、身份证）在医院自助服务终端上进行预约挂号业务。</span> 
                  </p>
                  <p class="MsoNormal" style="text-indent:21.0000pt;vertical-align:middle;">
                    <span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">自助预约挂号流程如下：在屏幕上选挂号</span><span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">/取号 → 依提示插入就诊卡（医保卡、身份证） → 选预约挂号业务 → 选预约日期 → 选门诊科室 → 选医生 → &nbsp;确认挂号（提示是否支付挂号费） → 打印业务凭证。</span> 
                  </p>
                  <p class="MsoNormal" style="text-indent:21.0000pt;vertical-align:middle;">
                    <span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;"><br>
                  </span>
                  </p>
                  <p class="MsoNormal" style="text-indent:21.0000pt;vertical-align:middle;">
                    <span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">三、预约取号</span> 
                  </p>
                  <p class="MsoNormal" style="text-indent:21.0000pt;vertical-align:middle;">
                    <span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">持就诊卡患者（医保卡、身份证）在医院自助服务终端上进行预约取号业务。</span> 
                  </p>
                  <p class="MsoNormal" style="text-indent:21.0000pt;vertical-align:middle;">
                    <span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">自助预约挂号流程如下：在屏幕上选挂号</span><span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">/取号 → 依提示插入就诊卡（医保卡、身份证） → 选预约取号业务 → 选取号 → 确认取号（如果未扣费直接扣费） → 打印业务凭证。</span> 
                  </p>
                  <p class="MsoNormal" style="text-indent:21.0000pt;vertical-align:middle;">
                    <span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;"><br>
                  </span>
                  </p>
                  <p class="MsoNormal" style="text-indent:21.0000pt;vertical-align:middle;">
                    <span style="font-size:16px;font-family:Arial;line-height:2;"> </span> 
                  </p>
                  <p class="MsoNormal" style="text-indent:21.0000pt;vertical-align:middle;">
                    <span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">四、取消预约号</span> 
                  </p>
                  <p class="MsoNormal" style="text-indent:21.0000pt;vertical-align:middle;">
                    <span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">持就诊卡患者（医保卡、身份证）在医院自助服务终端上进行取消预约号业务。</span> 
                  </p>
                  <p class="MsoNormal">
                    <span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">自助取消预约号流程如下：在屏幕上选挂号</span><span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">/取号 → 依提示插入就诊卡（医保卡、身份证） → 选取消预约号业务 → 选取消 → 确认取消（退还挂号费</span><span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;">）</span><span style="font-size:16px;font-family:Arial;line-height:2;color:#000000;"> → 打印业务凭证</span> 
                  </p>
                  <br>
                  <p>
                    <br>
                  </p>
                  <p>
                    <br>
                  </p>                
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "hospital-machineBook-hf",
  data() {
    return Object.assign(
      {
        radioValue: 1
      }
    );
  },
  mounted() {
    console.log("进入预约组件");
  },
  methods: {
    tabClick(value) {
      this.radioValue = value;
      this.radioValueChange(value);
    },
    radioValueChange(value) {
      // if (this.radioValue == 1) {
      //   document.querySelector(".a1").className = "a1 item now";
      //   document.querySelector(".a2").className = "a2";
      // } else {
      //   document.querySelector(".a2").className = "a2 now";
      //   document.querySelector(".a1").className = "a1";
      // }
      let select = ".a" + value;
      for (let i = 1; i <= 6; i++) {
        let removeNow = ".a" + i;
        if (i == value) {
          // document.querySelector(select).className = "a1 item now";
          document.querySelector(select).classList.add("now");
        } else {
          document.querySelector(removeNow).classList.remove("now");
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.guahaopage1 {
  // padding-top: 85px;
  padding-bottom: 125px;
  .title1 {
    text-align: center;
    font-size: 30px;
  }
  .pubctabs1 {
    padding-top: 50px;
    display: flex;
  }
  .pubctabs1 a:first-child {
    margin-left: 0;
  }
  .pubctabs1 a {
    // float: left;
    // width: 232px;
    width: 18%;
    height: 57px;
    line-height: 57px;
    font-size: 18px;
    margin-left: 17px;
    text-align: center;
    box-shadow: 0px 1px 12px 0px #ccc;

    text-decoration: none;
    color: inherit;
  }
  .pubctabs1 a.now {
    background: #0078d4;
    color: #fff;
  }
}

.guahao5page1 {
  margin-top: 33px;
  .item.now {
    background: #0078d4 url(../images/guahao5page1.png) no-repeat 3px center;
  }
  .leftbox {
    width: 286px;
    box-shadow: 0px 1px 12px 0px #ccc;
    // height: 390px;
    float: left;
    margin-right: 10px;
    .item:first-child {
      border-top: 0;
    }
    .item.now {
      background-color: #0078d4;
      a {
        color: #fff;
      }
      a:before {
        border-color: #fff;
      }
    }
    .item {
      padding: 0 20px;
      .li {
        padding: 12px 0;
        border-bottom: 1px dashed #dedede;
      }
      a:before {
        content: "";
        display: block;
        position: absolute;
        border-radius: 50%;
        width: 7px;
        height: 7px;
        border: 3px solid #cbcbcb;
        top: 6px;
        left: 1px;
      }
      a {
        padding-left: 26px;
        display: block;
        font-size: 16px;
        color: #333;
        position: relative;
      }
    }
  }

  .mCustomScrollBox {
    position: relative;
    overflow: hidden;
    height: 100%;
    max-width: 100%;
    outline: none;
    direction: ltr;
  }
  .mCSB_inside > .mCSB_container {
    margin: 0;
  }

  .mCSB_scrollTools {
    width: 8px;
    .mCSB_draggerContainer {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      height: auto;
    }
    .mCSB_dragger {
      cursor: pointer;
      width: 100%;
      height: 30px;
      z-index: 1;
    }

    .mCSB_draggerRail {
      width: 8px;
      background: #cccccc;
      border-radius: 0;
    }
  }

  .rightbox {
    box-shadow: 0px 1px 12px 0px #ccc;
    overflow: hidden;
    margin-top: 7px;
    .inner:first-child {
      display: block;
    }
    .inner {
      padding: 30px;
      display: none;
    }

    .box2 {
      padding-bottom: 40px;
    }

    .tit2 {
      font-size: 20px;
      border-bottom: 1px solid #dbdbdb;
      padding-bottom: 19px;
      position: relative;
      .s1 {
        height: 38px;
        line-height: 38px;
      }
    }
    .tit2:after {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      bottom: -2px;
      height: 3px;
      background: #0078d4;
      width: 60px;
    }

    .content {
      line-height: 22px;
      color: #707070;
      padding-top: 22px;
      img {
        display: initial;
      }
    }
  }
}

.m-screen-pc {
}
.m-screen-mobile {
  .guahaopage1{
    .title1 {
        font-size: 0.4rem;
    }
    .pubctabs1 {
        padding-top: 0.4rem;
        white-space: nowrap;
        overflow-x: auto;
    }
    .pubctabs1 a {
        float: none;
        display: inline-block;
        width: 2.6rem;
        height: 0.8rem;
        line-height: 0.8rem;
        font-size: 0.26rem;
        margin-left: 0.1rem;
    }
  }

  .guahao5page1 {
    margin-top: 0.4rem;
    .leftbox {
        width: auto;
        float: none;
        padding: 0 0 0.2rem;
        margin: 0;
        // height: 5rem;
        .item {
            padding: 0 0.3rem;
            .li {
                padding: 0.2rem 0;
            }
            a {
                font-size: 0.28rem;
                padding-left: 0.3rem;
            }
            a:before {
                width: 0.2rem;
                height: 0.2rem;
                border-width: 0.05rem;
                top: 0.1rem;
            }
        }
    }

    .rightbox {
        margin-top: 0.2rem;
        .inner {
            padding: 0.3rem;
        }
        .box2 {
            padding-bottom: 0.4rem;
        }
        .tit2 {
            font-size: 0.3rem;
            padding-bottom: 0.3rem;
            .s1 {
                height: 38px;
                line-height: 38px;
            }
        }
        .content {
            line-height: 1.6;
        }
    }
  }
  .x-wrap {
    width: auto;
    padding: 0 0.25rem;
  }

}
</style>
